import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import ModalDrawer from '../modals/ModalDrawer';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';
import { TRANSLATIONS } from '../../../translations';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import BetaIcon, { IconSizes } from '../Icons/Icon';
import { VoucherPreview } from './VoucherPreview';
import { voucherPreviewModalWidth } from '../../../constants';

const VoucherDuration = (props) => {
  if (!props.listingId) return null;

  const [showPreview, setShowPreview] = useState(false);
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);
  const voucherTemplate = <VoucherPreview listingId={props.listingId} productId={props.productId} />;

  return (
    <>
      <ModalDrawer
        content={voucherTemplate}
        title={TRANSLATIONS.VOUCHER_EXAMPLE}
        isOpen={showPreview}
        setIsOpen={setShowPreview}
        isDeviceSmallerThanTablet={isDeviceSmallerThanTablet}
        modalCustomWidth={voucherPreviewModalWidth}
      />

      <div
        className={classNames('voucher-duration', {
          'voucher-duration--margin-bottom': props.withMarginBottom,
        })}
      >
        <div className="w-100% justify-center d-flex items-start gap-base">
          <BetaIcon name={'gift'} size={IconSizes[20]} />
          <p className="voucher-duration__text">{app_main_wpml.voucher}</p>
        </div>

        {props.listingId && (
          <button
            className="displayExperiment w-100% pointer"
            type="button"
            onClick={() => setShowPreview(!showPreview)}
          >
            <Typography
              classNames={'typography__neutral'}
              variant={TypographyVariants.p3}
              state={TypographyStates.underlined}
            >
              {TRANSLATIONS.CHECK_PREVIEW}
            </Typography>
          </button>
        )}
      </div>
    </>
  );
};

VoucherDuration.propTypes = {
  className: PropTypes.string,
  withMarginBottom: PropTypes.bool.isRequired,
  listingId: PropTypes.number,
  productId: PropTypes.number,
};

VoucherDuration.defaultProps = {
  withMarginBottom: false,
  listingId: null,
};

export { VoucherDuration };
